import { ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const extendedTwMerge = extendTailwindMerge({
  prefix: "tw-",
});

export function cn(...args: ClassValue[]) {
  return extendedTwMerge(clsx(args));
}
